import { render, staticRenderFns } from "./update-current-user.vue?vue&type=template&id=4851f1e2&scoped=true&lang=pug&"
import script from "./update-current-user.vue?vue&type=script&lang=ts&"
export * from "./update-current-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851f1e2",
  null
  
)

export default component.exports